import { render, staticRenderFns } from "./FourPanel.vue?vue&type=template&id=343ed231&scoped=true&"
import script from "./FourPanel.vue?vue&type=script&lang=js&"
export * from "./FourPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ed231",
  null
  
)

export default component.exports